import { useState } from "react";
import TabBox from "src/Components/Tabbox/TabBox";
import Definition from "./Definition";
import AccountAssignment from "./AccountAssignment";

enum ActiveTab {
  Definition,
  AccountAssignment,
}

const GroupingSettings = () => {
  const [activeTab, setActiveTab] = useState(ActiveTab.Definition);

  const getUI = () => {
    switch (activeTab) {
      case ActiveTab.Definition:
        return <Definition />;
      case ActiveTab.AccountAssignment:
        return <AccountAssignment />;
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col justify-start items-start gap-3 borderrounded w-full p-3 h-full">
      <div className="max-w-min ml-5">
        <TabBox
          activeTab={activeTab}
          children={[
            { index: ActiveTab.Definition, title: "تعریف گروه پرتفو و تخصیص دارایی" },
            { index: ActiveTab.AccountAssignment, title: "تخصیص اکانت و تعیین اعتبار" },
          ]}
          onChange={(_, i) => setActiveTab(i)}
        />
      </div>
      {getUI()}
    </div>
  );
};

export default GroupingSettings;
